import React, { useEffect, useState, useRef } from 'react';
import Flickity from 'react-flickity-component';
import { get, forEach } from '../../../common/httpService';
import translateService from '../../../common/translateService';
import { isNil, join } from 'lodash';
import common from '../../../common/common';
import useWindowDimensions from '../../../hooks/useWindowDimensions';
import './TopBrands.scss';

function TopBrands({ brands }) {
    const flcktyRef = useRef(null);
    const itemWidth = 120;
    const lateralMarginSize = 60;
    const flcktyOption = {
        autoPlay: false,
        cellAlign: 'left',
        contain: true,
        draggable: common.isTouch(),
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        groupCells: '100%',
    };

    const [currentBrands, setBrands] = useState([]);
    const { width: windowWidth } = useWindowDimensions();
    const prefix = 'topBrands';

    useEffect(() => {
        let unmounted = false;
        try {
            async function fetchBrands(inputVal) {
                const inputValue = isNil(inputVal) ? [] : inputVal;
                let result = [];
                if (inputValue.length > 0) {
                    const joinedBrands = join(inputValue, ' ');
                    result = await get({
                        url:
                            'brandpage/searchbrandsbyslug?term=' +
                            encodeURIComponent(joinedBrands),
                    });
                }
                if (!unmounted) {
                    setBrands(result);
                }
            }
            fetchBrands(brands);
        } catch (error) {
            console.error('Error in TopBrands', error);
            setBrands([]);
        }

        return () => {
            unmounted = true;
        };
    }, [brands]);

    const renderedBrands = currentBrands.map((currentBrand, idx) => {
        return (
            <figure key={idx} style={{ width: '120px', height: '120px' }}>
                <a
                    className='top-brands-link'
                    itemProp='url'
                    href={`${common.getSiteUrl()}/${
                        currentBrand.slug
                    }/${translateService.get(`${prefix}.brands`)}`}
                    title={currentBrand.name}>
                    <img
                        itemProp='image'
                        src={currentBrand.logo}
                        alt={currentBrand.name}
                        style={{ width: '120px', height: '120px' }}
                    />
                </a>
            </figure>
        );
    });
    const itemsDontFit = (currentBrands) => {
        return (
            currentBrands &&
            currentBrands.length > 0 &&
            currentBrands.length * itemWidth > windowWidth - lateralMarginSize
        );
    };
    if (!currentBrands || currentBrands.length === 0) return <></>;

    if (itemsDontFit(currentBrands) || common.isTouch()) {
        return (
            <div className='top-brands'>
                <h1 className='section__title'>
                    {/* {translateService.get(`${prefix}.topBrands`)} */}
                </h1>
                <Flickity
                    className='product-slider'
                    ref={flcktyRef}
                    options={flcktyOption}>
                    {renderedBrands}
                </Flickity>
            </div>
        );
    }
    return (
        <div className='top-brands'>
            <div
                className='product-slider'
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                }}>
                {renderedBrands}
            </div>
        </div>
    );
}
export default TopBrands;
